import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { validateErrorIfSetWith, validateOptionalRequireIf } from '~/hooks/reactHookForm';
import { OutcomesFormProps } from '~pages/Dialler/ConnectDialler/VoiceView/OutcomeCapture';

const OutcomesForm = ({ formSubmitting }: OutcomesFormProps) => {
  const {
    control,
    getValues,
    formState: { errors },
  } = useFormContext();

  const validateOpportunityId = (value: string) => {
    const validateOptional = validateOptionalRequireIf(value, 'lead_id', getValues);
    if (!validateOptional) {
      return 'Opportunity is required';
    }
    const validateError = validateErrorIfSetWith(value, 'lead_id', getValues);
    if (!validateError) {
      return 'Cannot be set when Lead ID is set';
    }
    return true;
  };

  const validateLeadId = (value: string) => {
    const validateOptional = validateOptionalRequireIf(value, 'opportunity_id', getValues);
    if (!validateOptional) {
      return 'Lead ID is required';
    }
    const validateError = validateErrorIfSetWith(value, 'opportunity_id', getValues);
    if (!validateError) {
      return 'Cannot be set when Opportunity ID is set';
    }
    return true;
  };

  return (
    <>
      <Grid item xs={12}>
        <Controller
          name='opportunity_id'
          control={control}
          defaultValue={''}
          rules={{ validate: validateOpportunityId }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='opportunity_id'
              label='Opportunity ID'
              disabled={formSubmitting}
              error={Boolean(errors.opportunity_id)}
              helperText={errors.outlined?.message as string | undefined}
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          name='lead_id'
          control={control}
          defaultValue={''}
          rules={{ validate: validateLeadId }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='lead_id'
              label='Lead ID'
              disabled={formSubmitting}
              error={Boolean(errors.lead_id)}
              helperText={errors.lead_id?.message as string | undefined}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default OutcomesForm;
